<!-- 
  @license lucide-svelte v0.307.0 - ISC

This source code is licensed under the ISC license.
See the LICENSE file in the root directory of this source tree. 
-->

<script>import Icon from '../Icon.svelte';
const iconNode = [["path", { "d": "M15.6 2.7a10 10 0 1 0 5.7 5.7" }], ["circle", { "cx": "12", "cy": "12", "r": "2" }], ["path", { "d": "M13.4 10.6 19 5" }]];
</script>

<Icon name="gauge-circle" {...$$props} iconNode={iconNode}>
  <slot/>
</Icon>
